import { Flex } from "@jsq/ds/core";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { ScreeningRecord, ScreeningResultsOrStatus } from "../types";
import { parseScreeningRecord } from "./constants";
import { ScreeningStatusCell } from "./RiskRatingCell";

interface Props {
  params: AGGridCellRenderParams | { value: ScreeningRecord | null | undefined };
  type?: ScreeningResultsOrStatus;
}

export const ScreeningStatusRenderer = ({ params, type }: Props) => {
  const { icon, color, text } = parseScreeningRecord(
    params.value as ScreeningRecord,
    type as ScreeningResultsOrStatus,
  );
  return (
    <Flex alignItems="center" gap={4} data-testid={`${type}-renderer`}>
      <ScreeningStatusCell
        type={type}
        hasIcon={true}
        iconType={icon}
        color={color}
        text={text}
      />
    </Flex>
  );
};
